/* eslint-disable carsys-custom/mui-do-not-reference-classnames-via-string */
import * as React from 'react'
import Tabs, { tabsClasses } from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Box from '@mui/material/Box'
import { Button, CircularProgress } from '@mui/material'
import { Link, useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import CustomerTab from './CustomerTab'
import CustomerTabPanel from '../wrappers/CustomerTabPanel'
import Delivery from './Delivery'
import EcomPack from './EcomPack'
import PreCondition from './PreCondition'
import ConfirmationPage from './ConfirmationPage'
import { useDispatch, useSelector } from 'react-redux'
import { IRootReducerState } from 'state/reducers'
import { fetchCustomerProfileData } from '../state/actions'
import { useTranslation } from 'react-i18next'

interface CustomerObject {
  CustEosId: string
  CustNo: string
  CustName: string
  Location: string
  Street: string
  ZipCode: string
  CustEmail: string
  OuName: string
  ShipToLoc: string
  AppId: number
}

interface customerFormDataType {
  CustNo: string
  ShipToLoc: string
  OuName: string
  AppId: number | undefined
  ModuleId: string
  OverriddenByAdmin: boolean
  SignUpEmailOfCustomer: string
  SalesRepEmail: string | null
  ModulePrice: number
}
interface ApiResponse {
  Data: {
    Preconditions: {
      length: number
      Creditworthiness: string
      Threestepcustomer: string
      Deliveroptions: string
      Packageexists: string
    }
    Status: string
    AdminStatus: string
  }
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
    value: index
  }
}

export default function ProfileTabs() {
  const loggedUserInfo = useSelector((state: IRootReducerState) => state.auth.user)
  const loggedUser = loggedUserInfo ? { role: loggedUserInfo['custom:role'], email: loggedUserInfo.email } : { role: null, email: null }
  const customerId = useParams<{ customerId: string }>().customerId
  const [value, setValue] = useState(0)
  const [disableEcPackage, setDisableEcPackage] = useState(true)
  const [disablePreCondition, setDisablePreCondition] = useState(true)
  const [disableDelivery, setDisableDelivery] = useState(true)
  const [disbaleConfirmation, setDisbaleConfirmation] = useState(true)
  const [disableProceed, setDisableProceed] = useState(false)
  const [selectedPackage, setSelectedPackage] = useState(
    null as {
      ModuleID: string
      ModuleName: string
      Price: number
    } | null
  )
  const [SignUpEmailOfCustomer, setSignUpEmailOfCustomer] = useState('test@test.com')
  const [appId, setAppId] = useState(null as number | null)
  const [confirmationPopUpOpen, setConfirmationPopUpOpen] = useState(false)
  const [linkSendButtionActive, setLinkSendButtionActive] = useState(false)
  const [customerFormData, setCustomerFormData] = useState(null as customerFormDataType | null)
  const [customerProfile, setCustomerProfile] = useState(null as CustomerObject | null)
  const [preconditionStatus, setPreconditionStatus] = useState(null as ApiResponse | null)
  const bypasPopup = preconditionStatus?.Data.Status === 'Success'
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const App_Id = Number(useSelector((state: IRootReducerState) => state.auth?.user?.AppId))
  const fetchCustomerProfile = async (customerEosId: string) => {
    try {
      const response = await dispatch(fetchCustomerProfileData(customerEosId))
      const data = response.Data
      return data
    } catch (error) {
      console.error(error)
    }
  }

  useEffect(() => {
    const getCustomerProfile = async () => {
      const customerResult = await fetchCustomerProfile(customerId)
      if (customerResult !== null) {
        setCustomerProfile(customerResult)
        setSignUpEmailOfCustomer(customerResult?.CustEmail)
      }
    }
    getCustomerProfile()
  }, [customerId, dispatch])

  useEffect(() => {
    setCustomerFormData({
      CustNo: customerProfile?.CustNo || '',
      ShipToLoc: customerProfile?.ShipToLoc || '',
      OuName: customerProfile?.OuName || '',
      AppId: App_Id as number | undefined,
      ModuleId: selectedPackage?.ModuleID || '',
      OverriddenByAdmin: true,
      SignUpEmailOfCustomer,
      SalesRepEmail: loggedUser.email,
      ModulePrice: selectedPackage?.Price || 0
    })
  }, [customerProfile, selectedPackage, appId, SignUpEmailOfCustomer])

  const allowProceedToCustomers = (allow: boolean) => {
    setDisableProceed(!allow)
  }

  const disableAllNextTabs = (activeTabIndex: number) => {
    switch (activeTabIndex) {
      case 0:
        setDisableEcPackage(true)
        setDisablePreCondition(true)
        setDisableDelivery(true)
        setDisbaleConfirmation(true)
        break
      case 1:
        setDisablePreCondition(true)
        setDisableDelivery(true)
        setDisbaleConfirmation(true)
        break
      case 2:
        setDisableDelivery(true)
        setDisbaleConfirmation(true)
        break
      case 3:
        setDisbaleConfirmation(true)
        break
    }
  }

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue)
    disableAllNextTabs(newValue)
    setDisableProceed(false)
  }

  const handleProceed = () => {
    switch (value) {
      case 0:
        setDisableEcPackage(false)

        break
      case 1:
        setDisablePreCondition(false)

        break
      case 2:
        setDisableDelivery(false)

        break
      case 3:
        setDisbaleConfirmation(false)

        break
    }
    if (value > 3) {
      if (bypasPopup) {
        setConfirmationPopUpOpen(false)
        setLinkSendButtionActive(true)
      } else {
        setConfirmationPopUpOpen(true)
      }

      return
    }
    setValue(value + 1)
  }

  if (!customerProfile) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 1 }}>
        <CircularProgress size={20} role='progressbar' aria-label='Loading customer profile' />
      </Box>
    )
  }

  return (
    <Box sx={{ width: '100%' }}>
      {/* Tabs */}
      <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
        <Box>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label='basic tabs example'
            sx={{
              [`& .${tabsClasses.indicator}`]: {
                backgroundColor: 'white'
              }
            }}
          >
            <Tab
              label={t('Customers.CustomerGeneralTab')}
              {...a11yProps(0)}
              sx={{
                textTransform: 'none',
                backgroundColor: value === 0 ? 'white' : 'transparent',
                color: 'black',
                borderTopLeftRadius: '3px',
                borderTopRightRadius: '3px',
                borderTop: value === 0 ? '0.2px solid #D4D4D5' : 'none',
                borderLeft: value === 0 ? '0.2px solid #D4D4D5' : 'none',
                borderRight: value === 0 ? '0.2px solid #D4D4D5' : 'none',
                fontSize: '12px',
                fontWeight: '400',
                '&.Mui-disabled': {
                  color: '#444',
                  fontSize: '12px',
                  fontWeight: '400'
                },
                '&.Mui-selected': {
                  color: '#444',
                  fontSize: '12px',
                  fontWeight: '600'
                }
              }}
            />
            <Tab
              label={t('Customers.EcommercePackage')}
              {...a11yProps(1)}
              disabled={disableEcPackage}
              sx={{
                textTransform: 'none',
                backgroundColor: value === 1 ? 'white' : 'transparent',
                color: 'black',
                borderTopLeftRadius: '3px',
                borderTopRightRadius: '3px',
                borderTop: value === 1 ? '0.2px solid #D4D4D5' : 'none',
                borderLeft: value === 1 ? '0.2px solid #D4D4D5' : 'none',
                borderRight: value === 1 ? '0.2px solid #D4D4D5' : 'none',
                fontSize: '12px',
                fontWeight: '400',
                '&.Mui-disabled': {
                  color: '#444',
                  fontSize: '12px',
                  fontWeight: '400'
                },
                '&.Mui-selected': {
                  color: '#444',
                  fontSize: '12px',
                  fontWeight: '600'
                }
              }}
            />
            <Tab
              label={t('AppLabels.preCondition')}
              {...a11yProps(2)}
              disabled={disablePreCondition}
              sx={{
                textTransform: 'none',
                backgroundColor: value === 2 ? 'white' : 'transparent',
                color: 'black',
                borderTopLeftRadius: '3px',
                borderTopRightRadius: '3px',
                borderTop: value === 2 ? '0.2px solid #D4D4D5' : 'none',
                borderLeft: value === 2 ? '0.2px solid #D4D4D5' : 'none',
                borderRight: value === 2 ? '0.2px solid #D4D4D5' : 'none',
                fontSize: '12px',
                fontWeight: '400',
                '&.Mui-disabled': {
                  color: '#444',
                  fontSize: '12px',
                  fontWeight: '400'
                },
                '&.Mui-selected': {
                  color: '#444',
                  fontSize: '12px',
                  fontWeight: '600'
                }
              }}
            />
            <Tab
              label={t('Customers.Delivery')}
              {...a11yProps(3)}
              disabled={disableDelivery}
              sx={{
                textTransform: 'none',
                backgroundColor: value === 3 ? 'white' : 'transparent',
                color: 'black',
                borderTopLeftRadius: '3px',
                borderTopRightRadius: '3px',
                borderTop: value === 3 ? '0.2px solid #D4D4D5' : 'none',
                borderLeft: value === 3 ? '0.2px solid #D4D4D5' : 'none',
                borderRight: value === 3 ? '0.2px solid #D4D4D5' : 'none',
                fontSize: '12px',
                fontWeight: '400',
                '&.Mui-disabled': {
                  color: '#444',
                  fontSize: '12px',
                  fontWeight: '400'
                },
                '&.Mui-selected': {
                  color: '#444',
                  fontSize: '12px',
                  fontWeight: '600'
                }
              }}
            />
            <Tab
              label={t('Customers.Confirmation')}
              {...a11yProps(4)}
              disabled={disbaleConfirmation}
              sx={{
                textTransform: 'none',
                backgroundColor: value === 4 ? 'white' : 'transparent',
                color: value === 4 ? 'black' : 'inherit',
                borderTopLeftRadius: '3px',
                borderTopRightRadius: '3px',
                borderTop: value === 4 ? '0.2px solid #D4D4D5' : 'none',
                borderLeft: value === 4 ? '0.2px solid #D4D4D5' : 'none',
                borderRight: value === 4 ? '0.2px solid #D4D4D5' : 'none',
                fontSize: '12px',
                fontWeight: '400',
                '&.Mui-disabled': {
                  color: '#444',
                  fontSize: '12px',
                  fontWeight: '400'
                },
                '&.Mui-selected': {
                  color: '#444',
                  fontSize: '12px',
                  fontWeight: '600'
                }
              }}
            />
          </Tabs>
        </Box>

        <Box>
          <Link to='/LKQ/OfferPackage'>
            <Button variant='outlined' color='inherit' className='ui tiny ml-half' style={{ height: '35px', marginBottom: '1px' }}>
              <i className='arrow left icon' style={{ marginTop: '-10px' }} />
              {t('module.Back')}
            </Button>
          </Link>

          <Button
            type='submit'
            variant='contained'
            data-testid='savebtn'
            className='ui tiny ml-half'
            style={{ height: '35px', marginBottom: '1px' }}
            onClick={handleProceed}
            disabled={disableProceed}
          >
            {t('Form.Buttons.Next')}
          </Button>
        </Box>
      </div>

      {/* Tab Panels */}
      <Box
        sx={{
          width: '100%',
          backgroundColor: 'white',
          margin: '-1',
          border: '0.2px solid #D4D4D5',
          borderRadius: '0 3px 3px 3px'
        }}
        marginBottom={2}
      >
        <CustomerTabPanel value={value} index={0}>
          {customerProfile ? (
            <CustomerTab customer={customerProfile} allowProceed={allowProceedToCustomers} />
          ) : (
            <Box>{t('ProfileTabs.ConfirmTabInfoText')}</Box>
          )}
        </CustomerTabPanel>
        <CustomerTabPanel value={value} index={1}>
          <EcomPack
            allowProceed={allowProceedToCustomers}
            setAppId={setAppId}
            setSelectedPackage={setSelectedPackage}
            selectedPackage={selectedPackage}
            customer={customerProfile}
          />
        </CustomerTabPanel>
        <CustomerTabPanel value={value} index={2}>
          <PreCondition
            selectedPackage={selectedPackage}
            customer={customerProfile}
            allowProceed={allowProceedToCustomers}
            setPreconditionStatus={setPreconditionStatus}
          />
        </CustomerTabPanel>
        <CustomerTabPanel value={value} index={3}>
          <Delivery customer={customerProfile} allowProceed={allowProceedToCustomers} />
        </CustomerTabPanel>
        <CustomerTabPanel value={value} index={4}>
          <ConfirmationPage
            loggedUser={loggedUser}
            confirmationPopUpOpen={confirmationPopUpOpen}
            setConfirmationPopUpOpen={setConfirmationPopUpOpen}
            customerFormData={customerFormData}
            SignUpEmailOfCustomer={SignUpEmailOfCustomer}
            setSignUpEmailOfCustomer={setSignUpEmailOfCustomer}
            preconditionStatus={preconditionStatus}
            bypasPopup={bypasPopup}
            linkSendButtionActive={linkSendButtionActive}
            setLinkSendButtionActive={setLinkSendButtionActive}
            setDisableProceed={setDisableProceed}
          />
        </CustomerTabPanel>
      </Box>
    </Box>
  )
}
